import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { updateVoicemailSettings } from 'flow/actions/voicemail-actions';
import { selectHasCapability } from 'flow/selectors/ExtensionSelectors';
import SettingSelectableItem from 'flow/components/ui-components/SettingSelectableItem';
import useAppContext from 'flow/hooks/useAppContext';
import useContact from 'flow/hooks/useContact';
import useVoicemail from 'flow/hooks/useVoicemail';
import { Capabilities } from 'flow/utils/capability-utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var notificationSettings = {
  email: {
    noticeEmail: true,
    noticeSMS: false
  },
  sms: {
    noticeEmail: false,
    noticeSMS: true
  },
  both: {
    noticeEmail: true,
    noticeSMS: true
  },
  none: {
    noticeEmail: false,
    noticeSMS: false
  }
};
var EditVoicemailNotification = function EditVoicemailNotification(_ref) {
  var extensionKey = _ref.extensionKey,
    handleBack = _ref.handleBack;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var _useContact = useContact(),
    ownContact = _useContact.ownContact;
  var _useVoicemail = useVoicemail(extensionKey),
    voicemailSettings = _useVoicemail.voicemailSettings;
  var hasCapabilitySms = useAppSelector(function (state) {
    return selectHasCapability(state, extensionKey, Capabilities.SMS);
  });
  var selectedItem = function selectedItem() {
    return Object.keys(notificationSettings).find(function (key) {
      var _notificationSettings = notificationSettings[key],
        noticeEmail = _notificationSettings.noticeEmail,
        noticeSMS = _notificationSettings.noticeSMS;
      return noticeEmail === voicemailSettings.get('noticeEmail') && noticeSMS === voicemailSettings.get('noticeSMS');
    });
  };
  var handleChange = function handleChange(selected) {
    dispatch(updateVoicemailSettings(extensionKey, _objectSpread({
      key: voicemailSettings.get('key')
    }, notificationSettings[selected])));
    handleBack();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SettingSelectableItem, {
      isDisabled: !ownContact.get('email'),
      value: "email",
      onClick: handleChange,
      selected: selectedItem(),
      children: i18next.t('settings.voicemail_notify_email')
    }), hasCapabilitySms && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(SettingSelectableItem, {
        isDisabled: !ownContact.getIn(['mobile', 'number']),
        value: "sms",
        onClick: handleChange,
        selected: selectedItem(),
        children: i18next.t('settings.voicemail_notify_sms')
      }), /*#__PURE__*/_jsx(SettingSelectableItem, {
        isDisabled: !ownContact.get('email') || !ownContact.getIn(['mobile', 'number']),
        value: "both",
        onClick: handleChange,
        selected: selectedItem(),
        children: i18next.t('settings.voicemail_notify_both')
      })]
    }), /*#__PURE__*/_jsx(SettingSelectableItem, {
      value: "none",
      onClick: handleChange,
      selected: selectedItem(),
      children: i18next.t('settings.voicemail_notify_none')
    })]
  });
};
export default EditVoicemailNotification;